/**
 * Selectors
 */
const selectProductCmsBlocks = (state) => {
  if (
    state &&
    state.shopProducts &&
    state.shopProducts.show &&
    state.shopProducts.show.data &&
    state.shopProducts.show.data.attributes &&
    state.shopProducts.show.data.attributes.cms_blocks
  ) {
    return state.shopProducts.show.data.attributes.cms_blocks;
  }
  return false;
};

const selectProductData = (state) => {
  const { show } = state.shopProducts;
  if (show && show.data) {
    return show.data;
  }
  return false;
};

const selectProductDataAttributes = (state) => {
  const { show } = state.shopProducts;
  if (show && show.data && show.data.attributes) {
    return show.data.attributes;
  }
  return false;
};

const selectProductDataRelationships = (state) => {
  const { show } = state.shopProducts;
  if (show && show.data && show.data.relationships) {
    return show.data.relationships;
  }
  return false;
};

const selectProductIncluded = (state) => {
  const { show } = state.shopProducts;
  if (show && show.included) {
    return show.included;
  }
  return false;
};

// Selector to get a product by ID for a specific language
const selectProductById = (state, language, productId) => {
  return state.shopProducts.byIdDictionary[language]?.[productId] || null;
};

// Selector to get a product by slug for a specific language
const getProducIdtBySlug = (state, language, slug) => {
  return state.shopProducts.bySlugDictionary[language]?.[slug];
};

// Selector to get a product by slug for a specific language
const selectProductBySlug = (state, language, slug) => {
  const productId = state.shopProducts.bySlugDictionary[language]?.[slug];
  return productId
    ? state.shopProducts.byIdDictionary[language][productId]
    : null;
};

/** exports all actions as default */
const shopSelectors = {
  selectProductBySlug: selectProductBySlug,
  selectProductById: selectProductById,
  getProducIdtBySlug: getProducIdtBySlug,
  selectProductCmsBlocks: selectProductCmsBlocks,
  selectProductData: selectProductData,
  selectProductDataAttributes: selectProductDataAttributes,
  selectProductDataRelationships: selectProductDataRelationships,
  selectProductIncluded: selectProductIncluded,
};

export default shopSelectors;
